import Image from '@/components/UI/Image';
import { intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useMount } from 'ahooks';
import { useRef } from 'react';
import css from './index.module.scss';
type tab = {
    key: number;
    name: string;
    imgPath: string;
    content: {
        id: number;
        usageTime: string;
        timeUnit: string;
        power: string;
        useScenes: string;
        desc: string;
    }[];
};

export default function TabInfo({}: any) {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_max_static');

    const isAr = locale == 'sa';
    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    const tabs: tab[] = [
        {
            key: 1,
            name: t('2016Wh'),
            imgPath: '/media/deltamax/pc/tabinfo/c1.png',
            content: [
                {
                    id: 0,
                    usageTime: intlNumber(locale, 1.6),
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs4')),
                    power: t('29kWh/day'),
                    useScenes: t('Family Use'),
                    desc: t('FU_desc'),
                },
                {
                    id: 1,
                    usageTime: '12',
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs1')),
                    power: t('3Pt6kWh/day'),
                    useScenes: t('Extended Outage Use'),
                    desc: t('EOU_desc'),
                },
                {
                    id: 2,
                    usageTime: '1',
                    timeUnit: getFinalUnit(['fr', 'de'].includes(locale) ? t('OneDay') : t('Day'), t('Day1')),
                    power: t('1Pt88kWh/day'),
                    useScenes: t('Temporary Outage Use'),
                    desc: t('TOU_desc'),
                },
                {
                    id: 3,
                    usageTime: intlNumber(locale, 2.4),
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs4')),
                    power: t('20kWh/day'),
                    useScenes: t('RV Use'),
                    desc: '',
                },
            ],
        },
        {
            key: 2,
            name: t('4032Wh'),
            imgPath: '/media/deltamax/pc/tabinfo/c2.png',
            content: [
                {
                    id: 0,
                    usageTime: '3',
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs3')),
                    power: t('29kWh/day'),
                    useScenes: t('Family Use'),
                    desc: t('FU_desc'),
                },
                {
                    id: 1,
                    usageTime: '1',
                    timeUnit: getFinalUnit(['fr', 'de'].includes(locale) ? t('OneDay') : t('Day'), t('Day1')),
                    power: t('3Pt6kWh/day'),
                    useScenes: t('Extended Outage Use'),
                    desc: t('EOU_desc'),
                },
                {
                    id: 2,
                    usageTime: isAr ? '2' : '2',
                    timeUnit: getFinalUnit(t('Day'), t('Day2')),
                    power: t('1Pt88kWh/day'),
                    useScenes: t('Temporary Outage Use'),
                    desc: t('TOU_desc'),
                },
                {
                    id: 3,
                    usageTime: intlNumber(locale, 4.8),
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs4')),
                    power: t('20kWh/day'),
                    useScenes: t('RV Use'),
                    desc: '',
                },
            ],
        },
        {
            key: 3,
            name: t('6048Wh'),
            imgPath: '/media/deltamax/pc/tabinfo/c3.png',
            content: [
                {
                    id: 0,
                    usageTime: '5',
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs3')),
                    power: t('29kWh/day'),
                    useScenes: t('Family Use'),
                    desc: t('FU_desc'),
                },
                {
                    id: 1,
                    usageTime: intlNumber(locale, 1.5),
                    timeUnit: getFinalUnit(t('Day'), t('Day1')),
                    power: t('3Pt6kWh/day'),
                    useScenes: t('Extended Outage Use'),
                    desc: t('EOU_desc'),
                },
                {
                    id: 2,
                    usageTime: '3',
                    timeUnit: getFinalUnit(t('Day'), t('Day3')),
                    power: t('1Pt88kWh/day'),
                    useScenes: t('Temporary Outage Use'),
                    desc: t('TOU_desc'),
                },
                {
                    id: 3,
                    usageTime: intlNumber(locale, 7.3),
                    timeUnit: getFinalUnit(t('Hrs'), t('Hrs4')),
                    power: t('20kWh/day'),
                    useScenes: t('RV Use'),
                    desc: '',
                },
            ],
        },
    ];

    // console.log(tabs);

    const [tabPosition, setTabPosition] = useState({
        tabWidth: 133,
        offsetLeft: 720,
    });
    const [tabIndex, setTabIndex] = useState(3);

    const linkBox = useRef<HTMLDivElement>(null);

    const changeTabIndex = (e: any) => {
        const index = e.target.dataset.index;
        originalChange(index, e.target);
        e.preventDefault();
    };

    const originalChange = (index: number, target: any) => {
        const { clientWidth, offsetLeft } = target;
        setTabIndex(Number(index));
        setTabPosition({ tabWidth: clientWidth, offsetLeft: offsetLeft });
    };

    useMount(() => {
        try {
            if (linkBox?.current) {
                originalChange(1, linkBox.current.childNodes[0].childNodes[0]);
            }
        } catch (e) {}
    });

    return (
        <>
            <div className={css.tab_info}>
                <div className="tab_info_img">
                    {tabs.map((tab) => (
                        <div className={`imgItem ${tabIndex === tab.key ? 'show' : 'hide'}`} key={tab.key}>
                            <Image src={tab.imgPath} alt={tab.name} layout="fill" />
                        </div>
                    ))}
                </div>

                <div className="tabsPanel">
                    <div className="tabs" ref={linkBox}>
                        {tabs.map((tab: tab) => (
                            <div key={tab.key} className={`font-family-semibolder tab ${tab.key === tabIndex ? 'select' : ''}`}>
                                <a href="#" data-index={tab.key} onClick={changeTabIndex} aria-label={tab.name}>
                                    {tab.name}
                                </a>
                            </div>
                        ))}
                    </div>
                    <div
                        className="line"
                        style={{
                            width: `calc(${tabPosition.tabWidth}px)`,
                            left: `calc(${tabPosition.offsetLeft}px)`,
                        }}
                    ></div>
                </div>

                <div className="content">
                    {tabs
                        .find((tab: tab) => tab.key === tabIndex)
                        ?.content.map((card) => (
                            <div className="cardItem font-family-bold" key={tabIndex.key}>
                                <h3 className="useScenes font-family-semibolder">{card.useScenes}</h3>
                                <div className="power font-family-semibold">{card.power}</div>
                                <p className="desc font-family-semibold">{card.desc}</p>
                                <div className="usage">
                                    <span className="usageTime">{card.usageTime}</span>
                                    <span className="timeUnit"> {card.timeUnit}</span>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
}
